/**
 * 列表项目
 */

import React from 'react';
import styled from 'styled-components';
import { hoc } from '@/lib';

import gamesFightUtils from '../utils';
import PopupInvite from './index';

type Props = {
  item: any;
  isParty?: boolean;
};
const ListItem = (props: Props) => {
  const { item, isParty } = props;

  const handleInvite = (item) => {
    gamesFightUtils.checkFightStatus(item.roomId || item.uid).then(() => {
      hoc.render({ item, stage: 'lunch', isParty }, PopupInvite);
    });
  };

  return (
    <Wrap>
      <img
        className="avatar"
        src={item.pic || 'https://img.sumeme.com/3/3/1559108259459.png'}
      />
      <div className="info">
        <p className="info-nick  text-overflow">{item.nickname || '多人厅'}</p>
        <span className="info-desc">ID: {item.roomId || item.uid}</span>
      </div>
      {item.live ? (
        <button className="btn btn-md" onClick={() => handleInvite(item)}>
          邀请PK
        </button>
      ) : (
        <button className="btn btn-md btn-grey">
          {isParty ? '暂未开厅' : '暂未开播'}
        </button>
      )}
    </Wrap>
  );
};

const Wrap = styled.li`
  position: relative;
  list-style: none;
  display: flex;
  height: 80px;
  align-items: center;
  ._dark & {
    .info-nick {
      color: #ffffff;
    }
    &:after {
      background-color: #454d56;
    }
  }

  &:after {
    position: absolute;
    left: 68px;
    bottom: 0;
    width: 368px;
    content: '';
    display: block;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .info {
    &-nick {
      display: block;
      font-size: 14px;
      font-weight: 500;
      max-width: 130px;
    }
    &-desc {
      font-size: 12px;
      font-weight: 400;
      color: #8a8aa2;
    }
  }
  .btn {
    margin-left: auto;
    width: 80px;
    height: 30px;
    background: linear-gradient(270deg, #c669ff 0%, #7555f7 100%);
    border-radius: 30px;
    color: #ffffff;
    border: 0;
    font-size: 14px;
    &-grey {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export default ListItem;
